import React from 'react';
import {RefreshButton} from './RefreshButton.js';

export const PageRefreshButton = ({...props}) => {

    return (
        <RefreshButton onClick={() => window.location.reload()} {...props} />
    );
};

